import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import Home from '../pages/Home';
import Detail from '../pages/Detail';
import Categories from '../pages/Categories';
import Items from '../pages/Items';
import Item from '../pages/Item';
import Comments from '../pages/Comments';
import Order from '../pages/Order';
import Sign from '../pages/Sign';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Home} isPrivate />
      <Route path="/detail" exact component={Detail} isPrivate />
      <Route path="/categories" exact component={Categories} isPrivate />
      <Route path="/items" exact component={Items} isPrivate />
      <Route path="/item" exact component={Item} isPrivate />
      <Route path="/comments" exact component={Comments} isPrivate />
      <Route path="/order" exact component={Order} isPrivate />
      <Route path="/sign" exact component={Sign} />
    </Switch>
  );
}
